import Component from '../abstracts/Component';

export default class PrivacyUnsubscribeComponent extends Component {

  get SELECTORS() {
    return {
      applySubscriptions: '.js-apply-subscriptions-options',
      privacyList: '#updatePrivacyForm .ch-pri__privacy-list',
      updatePrivacyForm: '#updatePrivacyForm',
      modalOk: '.my-account-unsubscribe-modal .privacy-ok',
      modalKo: '.my-account-unsubscribe-modal .privacy-ko',
      conditionInput: '.second-condition input',
    };
  }

  constructor() {
    super();
    this.applySubscriptions = document.querySelector(this.SELECTORS.applySubscriptions);
    this.privacyLists = document.querySelectorAll(this.SELECTORS.privacyList);
    this.updatePrivacyForm = document.querySelector(this.SELECTORS.updatePrivacyForm);
    this.modalOk = document.querySelector(this.SELECTORS.modalOk);
    this.modalKo = document.querySelector(this.SELECTORS.modalKo);
  }

  initFormUnsubscribe() {
    let ctx = this;

    this.applySubscriptions.addEventListener('click.fu', function (e) {
      e.preventDefault();
      var err = true;

      this.privacyLists.forEach((el, index) => {
        var currNL_el = el.querySelectorAll("input[name='currentProfiling[" + index + "].newsletter']")[0];
        var currPR_el = el.querySelectorAll("input[name='currentProfiling[" + index + "].profiled']")[0];

        if (currNL_el.checked || currPR_el.checked) {
          err = false;
          return false;
        }
      });
      ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
        button: this,
      });
      this.updatePrivacyForm.submit();
      return true;
    });
  }

  optionNewsletter() {
    // click on radio
    document.querySelectorAll(this.SELECTORS.privacyList && this.SELECTORS.conditionInput).forEach((secondInput) => {
      secondInput.addEventListener('click', () => {
        let secondCondition = secondInput.closest('.second-condition');
        if (secondInput.value == 'false') {
          // i show the select
          secondCondition.querySelector('.show-select').classList.remove('--hidden');
          this.setCollapsedHeight(secondCondition);
        } else {
          // i hid the select and reset values
          secondCondition.querySelector('select')[0].value = '';
          secondCondition.querySelector('select').value = '';
          secondCondition.querySelector('.show-select').classList.add('--hidden');
          this.setCollapsedHeight(secondCondition);
        }
      });
    });
  }

  setCollapsedHeight(radioButton) {
    const tab = radioButton.closest("[data-tab]");
    //rest height
    tab.style.height = null;
    tab.style.height = tab.offsetHeight + "px";
  }

  render() {
    this.log("Rendering...");
    this.modalOk.addEventListener('click.pok', function () {
      this.updatePrivacyForm.append("<input type='hidden' name='delete-profile' value='delete-profile'/>");
      document.querySelector('#updatePrivacyForm, #recallForm').submit();
      document.querySelector('.vex-close').click();
    });

    this.modalKo.addEventListener('click.pko', function () {
      document.querySelector('.vex-close').click();
    });

    this.initFormUnsubscribe();
    this.optionNewsletter();
  }
}
